import React from "react";
import ContentCard from "@/components/ContentCard";
import PageLayout from "@/components/PageLayout";

const About = () => {
  return (
    <PageLayout
      title="About Skadisfinity Layout"
      description="Skadisfinity Layout is an open-source planning tool for printable Skadis-style organization boards."
    >
      <ContentCard title="What This Site Does">
        <p>
          Skadisfinity Layout helps makers plan printable Skadis-compatible
          board layouts from real-world dimensions. The tool calculates board
          pieces, shows the remaining trim area, and checks the selected printer
          build volume so the chosen layout is realistic before printing.
        </p>
        <p>
          The site is designed for people building modular workshop, office,
          hobby, and desk organization systems. It is most useful before slicing
          or modeling, when a maker needs to decide whether a layout should use
          full-size boards, smaller edge boards, or a different print profile.
        </p>
      </ContentCard>

      <ContentCard title="Why It Exists">
        <p>
          Skadis-style boards are simple in concept, but planning a clean wall
          or drawer installation can still involve repeated measuring, printer
          limits, and spacer tradeoffs. Skadisfinity Layout turns those repeated
          layout questions into a visual calculator.
        </p>
        <p>
          The goal is uniformity for Skadis builders: consistent board sizing,
          clearer visual previews, and fewer surprises when a calculated board
          needs to fit a real build plate.
        </p>
      </ContentCard>

      <ContentCard title="Open Source">
        <p>
          The project is public on GitHub so layout behavior, printer presets,
          and print-profile assumptions can be reviewed. Contributions and
          issue reports are welcome through the repository.
        </p>
      </ContentCard>
    </PageLayout>
  );
};

export default About;
